'use strict';

const { queryFirst, queryAll, hasClass } = require('lilly/domUtil');
const { getNestedValue } = require('lilly/util');
const { bindGA } = require('./util/analytics-util');
const { SELECT_PROMO, VIEW_ITEM_LIST, VIEW_ITEM, PDP_INTERACTION, SELECT_ITEM, CONTENT_SLOT_SELECTORS } = require('./util/constants');

const { utag_data: uData } = window;

/**
 * Analytics Events for stylitics widgets
 */
function initEvents() {
    const styliticsWidget = queryFirst('#stylitics-widget');

    // Promo Click Event -- impressions are handled by the global promo impression event,
    // but clicks are handled here. The no-ga-clicks class on the widget prevents the global promo click events.
    bindGA(styliticsWidget, (bindElement, srcElement, e) => {
        const bundle = getNestedValue(e, 'data.bundle');
        if (!bundle) return false;

        const { promoId, promoName, promoCreative } = bindElement.dataset;
        const containerClass = CONTENT_SLOT_SELECTORS.find(selector => hasClass(bindElement, selector.slice(1)));
        const slotPosition = queryAll(containerClass).indexOf(bindElement) + 1;

        return {
            event_name: SELECT_PROMO,
            promo_id: promoId ? [promoId] : [],
            promo_name: promoName ? [promoName] : [],
            promo_creative: promoCreative ? [promoCreative] : [],
            promo_position: slotPosition ? [slotPosition] : []
        };
    }, {
        eventType: 'stylitics:click_bundle',
        isCustomEvent: true,
        updatesUDO: false,
        omitUADefaults: true,
        usesDataset: false
    });

    // bundle click - view item list event
    bindGA(styliticsWidget, (bindElement, srcElement, e) => {
        const bundle = getNestedValue(e, 'data.bundle');
        if (!bundle) return false;

        const items = bundle.items || [];
        const bundlePosition = bundle.position + 1 || '';
        const numItems = items.length;
        const { promoName: widgetTitle } = bindElement.dataset;

        const productIds = [];
        const productNames = [];
        const productColors = [];
        const productOrigPrices = [];
        const productPrices = [];
        const productCategories = [];
        const productVariants = [];

        items.forEach(item => {
            productNames.push(item.name);
            productIds.push(item.product_id);
            productColors.push(item.retailer_color);
            productOrigPrices.push(item.price);
            productPrices.push(item.sale_price);
            productCategories.push(item.department);
            productVariants.push(`${item.name}|${item.remote_id}`);
        });

        return {
            event_name: VIEW_ITEM_LIST,
            product_list: `${widgetTitle} - ${bundlePosition}`,
            product_name: productNames,
            product_id: productIds,
            product_price: productPrices,
            product_original_price: productOrigPrices,
            product_list_position: new Array(numItems).fill().map((_, index) => index + 1),
            product_category: productCategories,
            product_quantity: [],
            product_variant: productVariants,
            __affiliation: new Array(numItems).fill(uData.affiliation)
        };
    }, {
        eventType: 'stylitics:click_bundle',
        isCustomEvent: true,
        updatesUDO: false,
        omitUADefaults: true,
        usesDataset: false
    });

    // Stylitics - Product Click
    bindGA(styliticsWidget, (bindElement, srcElement, e) => {
        const item = getNestedValue(e, 'data.item');
        const bundle = getNestedValue(e, 'data.bundle');
        const itemElem = getNestedValue(e, 'data.itemElem');
        if (!item || !bundle || !itemElem) return false;

        const { promoName: widgetTitle } = bindElement.dataset;
        const { name, product_id: id, remote_id: variationGroup, price, sale_price: salePrice, department, retailer_category: category } = item;

        // calculate item position
        const allItems = queryAll('.stylitics-item-container');
        const itemPosition = (allItems && itemElem) ? allItems.indexOf(itemElem) + 1 : '';

        return {
            event_name: SELECT_ITEM,
            product_list: `${widgetTitle} - ${bundle.position + 1}`,
            product_name: name ? [name] : [],
            product_id: id ? [id] : [],
            product_price: price ? [price] : [],
            product_original_price: salePrice ? [salePrice] : [],
            product_category: department ? [department] : [],
            product_variant: name && variationGroup ? [`${name}|${variationGroup}`] : [],
            product_list_position: itemPosition ? [itemPosition] : [],
            product_list_category: category ? [category] : []
        };
    }, {
        eventType: 'stylitics:click_product',
        isCustomEvent: true,
        updatesUDO: false,
        omitUADefaults: true,
        usesDataset: false
    });

    // Stylitics - Product View
    bindGA(styliticsWidget, (bindElement, srcElement, e) => {
        const item = getNestedValue(e, 'data.item');
        const pdpType = getNestedValue(e, 'data.pdpType');
        if (!item) return false;

        const { name, product_id: id, remote_id: variationGroup, price, sale_price: salePrice, department } = item;

        return {
            event_name: VIEW_ITEM,
            pdp_type: pdpType || '',
            product_name: name ? [name] : [],
            product_id: id ? [id] : [],
            product_price: price ? [price] : [],
            product_original_price: salePrice ? [salePrice] : [],
            product_category: department ? [department] : [],
            product_variant: name && variationGroup ? [`${name}|${variationGroup}`] : []
        };
    }, {
        eventType: 'stylitics:click_product',
        isCustomEvent: true,
        updatesUDO: false,
        omitUADefaults: true,
        usesDataset: false
    });

    // Stylitics - PDP Jumplink
    bindGA(queryFirst('.product-detail'), (bindElement, srcElement) => {
        const widgetId = srcElement.getAttribute('href');
        const widget = queryFirst(widgetId, bindElement);

        if (!widget) return false;

        const { promoName: widgetTitle } = widget.dataset;

        return {
            event_name: PDP_INTERACTION,
            interaction_type: `jumplink - ${widgetTitle}`,
            page_product: uData.page_product
        };
    }, {
        omitUADefaults: true,
        usesDataset: false,
        bindOptions: {
            targetSelectors: ['.stylitcs-jump-link']
        }
    });
}

initEvents();
